/**
 * App metadata. Prefer VITE_APP_VERSION in .env for releases.
 * @see https://vitejs.dev/guide/env-and-mode
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '1.0.0';

export const APP_NAME = 'SEL TECHNOLOGIES';
export const APP_TAGLINE = 'ENTERPRISE SUITE';

// Optional: set VITE_APP_LOGO_URL in .env to a Cloudflare/R2 public URL for the SEL logo.
// Falls back to a local path that you can serve from the frontend (e.g. public/sel-logo.png).
export const APP_LOGO_URL =
  import.meta.env.VITE_APP_LOGO_URL || 'https://assets.prakriya.work/dac44227-6f2d-4ecc-8e90-da45c3247b02/image/1773221642663-9944082a-49c3-408e-9411-9e7ad491f9f2.png';
